<template>
  <div>
    <!-- Trigger Button -->
    <v-btn 
      :disabled="disabled" 
      color="primary" 
      :loading="loading" 
      @click="fetch" 
      text
      class="font-weight-black text-uppercase tracking-widest rounded-lg px-4 transition-fast-in-fast-out h-44"
    >
      <v-icon left size="16">fas fa-file-export</v-icon>
      Exportar Bitacora
    </v-btn>

    <!-- Download Dialog -->
    <v-dialog v-model="dataReady" max-width="400" transition="scale-transition">
      <v-card class="modern-card overflow-hidden rounded-xl">
        <!-- Premium Header -->
        <div class="bg-grey-light pa-6 border-bottom">
          <div class="d-flex align-center">
            <v-avatar color="primary" size="40" class="mr-4 shadow-sm border-white-sm">
              <v-icon color="white" small>fas fa-download</v-icon>
            </v-avatar>
            <div>
              <div class="text-h6 font-weight-black primary--text lh-1">Exportar Bitácora</div>
              <div class="caption grey--text font-weight-bold text-uppercase tracking-wider mt-1">Registros de producción</div>
            </div>
          </div>
        </div>

        <v-card-text class="text-center pa-8">
          <v-avatar color="primary lighten-5" size="80" class="mb-6">
            <v-icon color="primary" size="40">fas fa-history</v-icon>
          </v-avatar>
          <div class="body-1 primary--text font-weight-bold mb-2">¡Registros Listos!</div>
          <div class="caption grey--text px-4 mb-6">El historial de producción filtrado ha sido procesado para su descarga.</div>

          <vue-json-to-csv
            :json-data="items"
            :labels="labels"
            :csv-title="csvTitle"
            :separator="';'"
            @success="val => handleSuccess(val)"
            @error="val => handleError(val)">
            <v-btn 
              color="success" 
              block 
              large 
              elevation="0"
              height="48"
              class="font-weight-black text-none rounded-lg shadow-sm"
            >
              <v-icon left>fas fa-download</v-icon>
              Descargar CSV
            </v-btn>
          </vue-json-to-csv>
        </v-card-text>

        <v-divider class="mx-8 opacity-10"></v-divider>
        <div class="pa-4 text-center">
          <v-btn text small color="grey" class="text-none font-weight-bold" @click="dataReady = false">Cerrar</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import notifications from '@/utils/notifications'
import VueJsonToCsv from 'vue-json-to-csv'
import numeral from 'numeral'
import moment from 'moment'
import {fetchBitacora} from '@/api/production'

export default {
  name: "ExportProductionBitacora",
  props: ['options', 'disabled', 'filter'],
  components: { VueJsonToCsv },
  data() {
    return {
      loading: false,
      dataReady: false,
      items: [],
      labels: {
        created_at: { title: 'Fecha' },
        work_order: { title: 'OT' },
        customer_name: { title: 'Cliente' },
        product_sku: { title: 'SKU' },
        product_name: { title: 'Producto' },
        product_qty: { title: 'Cantidad' },
        product_mts2: { title: 'Total Mts2' },
        machine_name: { title: 'Area' },
        equipment_name: { title: 'Equipo' },
        production: { title: 'Producido' },
        unit: { title: 'Unidad' },
        start: { title: 'Inicio' },
        end: { title: 'Fin' },
        duration: { title: 'Duracion' },
        created_by: { title: 'Creado por' },
        notes: { title: 'Notas' },
      },
      csvTitle: `export_production_bitacora_${moment(new Date().toISOString()).format('DD-MM-yyyy_HH:mm')}`
    }
  },
  methods: {
    async fetch() {
      this.loading = true
      var created_before = ''
      var created_after = ''
      if (this.filter.created_after) created_after = moment(this.filter.created_after).utc().format('yyyy-MM-DD HH:mm')
      if (this.filter.created_before) created_before = moment(this.filter.created_before).utc().add(1439, 'minutes').format('yyyy-MM-DD HH:mm')

      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      const query = `ordering=${sortDesc && sortDesc[0] ? sortBy[0] : '-' + (sortBy ? sortBy[0] : 'id')}&page=${page || 1}&created_after=${created_after}&created_before=${created_before}&process_order__machine__id=${this.filter.machine?.id || ''}&equipment__id=${this.filter.equipment || ''}`
      
      await fetchBitacora(query)
        .then((data) => {
          this.items = data.results.map(item => ({
            created_at: moment(item.created_at).format('DD-MM-YYYY HH:mm'),
            work_order: item.work_order,
            customer_name: item.customer_name,
            product_sku: item.product_sku,
            product_name: item.product_name.replace(/"/g, ''),
            product_qty: item.product_qty,
            product_mts2: item.product_mts2,
            machine_name: item.machine_name,
            equipment_name: item.equipment_name,
            production: item.machine_production_unit_m2 ? item.mts2 : item.qty,
            unit: item.machine_production_unit_m2 ? 'mts2' : 'unidades',
            created_by: item.created_by,
            notes: item.notes,
            start: item.start ? moment(item.start).format('DD-MM-YYYY HH:mm') : '',
            end: item.end ? moment(item.end).format('DD-MM-YYYY HH:mm') : '',
            duration: item.duration || 0,
          }))
          this.dataReady = true
        })
        .catch((err) => notifications.showError('Error Cargando Bitácora: ' + err))
        .finally(() => this.loading = false)
    },
    handleSuccess(val) {
      notifications.showSuccess('Bitácora Exportada')
      this.dataReady = false
    },
    handleError(val) {
      notifications.showError('Error Exportando Bitácora')
      this.dataReady = false
    }
  }
}
</script>

<style scoped>
.modern-card { border-radius: 12px !important; font-family: 'Outfit', sans-serif !important; }
.bg-grey-light { background-color: #f8fafc !important; }
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.06) !important; }
.border-white-sm { border: 2px solid white !important; }
.shadow-sm { box-shadow: 0 4px 12px rgba(0,0,0,0.05) !important; }
.h-44 { height: 44px !important; }
.lh-1 { line-height: 1 !important; }
.tracking-widest { letter-spacing: 1.5px; }
.tracking-wider { letter-spacing: 0.8px; }
</style>